import { render, staticRenderFns } from "./comBookingSpace.vue?vue&type=template&id=483eb7c8&scoped=true"
import script from "./comBookingSpace.vue?vue&type=script&lang=js"
export * from "./comBookingSpace.vue?vue&type=script&lang=js"
import style0 from "./comBookingSpace.vue?vue&type=style&index=0&id=483eb7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483eb7c8",
  null
  
)

export default component.exports